import type { MailingListsMenuProps } from './types/mailing-lists-menu.props';

import MailingTypeMenu from './mailing-type-menu';

const MailingListsMenu = ({ isActive }: MailingListsMenuProps) => {
  return (
    <MailingTypeMenu
      isActive={isActive}
      label="List Manager"
      pathSegment="listmanager"
    />
  );
};

export default MailingListsMenu;
